import { Icon } from 'elements';
import * as React from 'react';
import { RichText } from 'elements/components/RichText';
import { SanitizeConfigOptions } from 'elements/utils/sanitization';
import { WrappedMessage } from 'utils';
import messages from '../../displayMessages';

interface TopicPageHeaderProps {
  learningObjectives: string[];
}

export const LearningObjectives: React.FC<TopicPageHeaderProps> = (props) => {
  const itemCount = props.learningObjectives.length;
  return (
    <div className='learning-objectives-wrapper section'>
      <div>
        <div className='header'>
          <Icon
              name='learning-objective'
              className='learning-objective-icon'
          />
          <h3 className='font-xs-lt'>
            <WrappedMessage
              message={messages.moduleLearningObjectives}
              values={{ itemCount }}
            />
          </h3>
        </div>

        <div className='learning-objectives-list'>
          {props.learningObjectives.length > 1 ?
            <ol>{props.learningObjectives.map((lo, index) =>
              <li key={index}>
                <RichText
                    innerHtml={lo}
                    sanitizeConfig={SanitizeConfigOptions.UnsafeHTMLSimple}
                />
              </li>
            )}
            </ol>
            :
            <RichText
                innerHtml={props.learningObjectives[0]}
                sanitizeConfig={SanitizeConfigOptions.UnsafeHTMLSimple}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default LearningObjectives;
